import styled from "styled-components";
import { CROUTON_BACKGROUND } from "@super-ui/components/black-membership-widgets/constants";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";

export const CroutonLogo = styled.div(({ theme }) => ({
    marginRight: theme.spacing.xxSmall,
}));

export const PostTextElement = styled.div(() => ({
    width: "30px",
}));

export const croutonStyles = {
    background: CROUTON_BACKGROUND,
    position: "relative",
    width: "91%",
    paddingLeft: BaseTheme.spacing.xSmall,
    paddingRight: `calc(${BaseTheme.spacing.xxLarge} + ${BaseTheme.spacing.xSmall})`,
    paddingTop: BaseTheme.spacing.medium,
    paddingBottom: BaseTheme.spacing.medium,
} as React.CSSProperties;

export const CroutonTextContainer = styled.div(() => ({
    display: "flex",
    marginTop: BaseTheme.spacing.xxSmall,
    ":first-child": {
        marginTop: 0,
    },
}));

export const closeIconStyles = (isOnlyOneLine: boolean) => {
    if (!isOnlyOneLine) {
        return {};
    }
    return {
        top: "50%",
        transform: "translateY(-50%)",
    };
};
